import { Injectable } from "@angular/core";
import { getActiveEditable, ListenerGroup } from "./shared/keyboard-viewport.util";

const PANEL_SELECTOR = '.mat-autocomplete-panel, .mat-mdc-autocomplete-panel';
const PANE_SELECTOR = '.cdk-overlay-pane';
const FOLLOW_TOLERANCE_PX = 96;

// keeps an open autocomplete panel attached to its field while the field's scroller moves
@Injectable({ providedIn: 'root' })
export class RpKeyboardOverlayAnchorService {

    private listeners = new ListenerGroup();
    private pane: HTMLElement | null = null;
    private anchorTop = 0;

    start(): void {
        if (this.listeners.active || typeof document === 'undefined') {
            return;
        }
        this.listeners.add(document, 'scroll', event => this.onScroll(event), { capture: true, passive: true });
    }

    stop(): void {
        this.listeners.clear();
        this.release();
    }

    private onScroll(event: Event): void {
        const panel = document.querySelector<HTMLElement>(PANEL_SELECTOR);
        const anchor = getActiveEditable();
        if (!panel || !anchor) {
            this.release();
            return;
        }
        const pane = panel.closest<HTMLElement>(PANE_SELECTOR);
        const target = event.target;
        if (!pane || (target instanceof Node && pane.contains(target))) {
            return;
        }
        if (pane !== this.pane) {
            this.adopt(pane, anchor);
            return;
        }
        const travelled = Math.round(anchor.getBoundingClientRect().top - this.anchorTop);
        if (Math.abs(travelled) > FOLLOW_TOLERANCE_PX) {
            this.dismissWithEscape(anchor);
            return;
        }
        pane.style.transform = travelled === 0 ? '' : `translateY(${travelled}px)`;
    }

    private adopt(pane: HTMLElement, anchor: HTMLElement): void {
        this.release();
        this.pane = pane;
        this.anchorTop = Math.round(anchor.getBoundingClientRect().top);
    }

    private dismissWithEscape(anchor: HTMLElement): void {
        this.release();
        anchor.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true, cancelable: true }));
    }

    private release(): void {
        if (this.pane) {
            this.pane.style.transform = '';
        }
        this.pane = null;
        this.anchorTop = 0;
    }
}
